// extracted by extract-css-chunks-webpack-plugin
module.exports = {"price":"Price__price","price_discount":"Price__price_discount","price_soldOut":"Price__price_soldOut","price__sale":"Price__price__sale"};